import React from 'react';
import Slider from '@mui/material/Slider';
import { RANGE_SLIDER_EXTRA_CSS } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';
import { RANGE_SLIDER_LABEL_EXTRA_CSS } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';
import { RANGE_SLIDER_RAILING_EXTRA_CSS } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';
import { RANGE_SLIDER_THUMB_EXTRA_CSS } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';
import { RANGE_SLIDER_TRACK_EXTRA_CSS } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';
import { RangeSliderInputWrapper } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputCommon';
import { RangeSliderInputSameMinMaxFake } from 'apps/sigma2-ui/src/filters-v2/components/RangeSliderInputSameMinMaxFake';

export interface RangeSliderInputProps {
  /**
   * Callback when slider value changes
   */
  onChange: (newValue: [number, number]) => void;

  /**
   * Minimum value of the slider
   */
  minimum: number;

  /**
   * Maximum value of the slider
   */
  maximum: number;

  /**
   * Current values of the slider
   */
  values: [number, number];

  /**
   * The number of decimal places to support step sizes of
   */
  precision: number;
}

export const RangeSliderInput = ({
  onChange,
  minimum,
  maximum,
  values,
  precision,
}: RangeSliderInputProps) => {
  const isSame = minimum === maximum;

  if (isSame) {
    return <RangeSliderInputSameMinMaxFake value={minimum} />;
  }
  return (
    <RangeSliderInputWrapper>
      <Slider
        value={values}
        min={minimum}
        max={maximum}
        disableSwap={true}
        step={1 / Math.pow(10, precision)}
        shiftStep={1 / Math.pow(10, precision)}
        valueLabelDisplay={'on'}
        size={'medium'}
        sx={{
          color: 'primary',
          '&': RANGE_SLIDER_EXTRA_CSS,
          '& .MuiSlider-thumb::before': {
            boxShadow: 'none',
          },
          '& .MuiSlider-thumb': { ...RANGE_SLIDER_THUMB_EXTRA_CSS, zIndex: 1 },
          '& .MuiSlider-thumb.Mui-active': {
            zIndex: 2,
          },

          '& .MuiSlider-track': RANGE_SLIDER_TRACK_EXTRA_CSS,
          '& .MuiSlider-rail': RANGE_SLIDER_RAILING_EXTRA_CSS,
          '& .MuiSlider-valueLabel.MuiSlider-valueLabelOpen':
            RANGE_SLIDER_LABEL_EXTRA_CSS,
          '& .MuiSlider-valueLabel::before': {
            content: 'none',
          },
        }}
        onChange={(_, newValue) => {
          if (!Array.isArray(newValue) || newValue.length !== 2) {
            return;
          }

          onChange([newValue[0], newValue[1]]);
        }}
      />
    </RangeSliderInputWrapper>
  );
};
